import { createAction } from '@reduxjs/toolkit';

import { USER_SEGMENTS } from 'store/constants/actions';
import { ISegment } from 'store/types/actions';

export const setUserSegmentsList = createAction<ISegment[] | null>(
  USER_SEGMENTS.SET_USER_SEGMENTS_LIST,
);
